
export const IDADE_ENUM = {
    sessentaQuatro: 64,
    sessentaCinco: 64
};

export const validatorDependenteSemValorAdicional = valoresForm => {
    const arrayDeValidacoes = [
        (verificarParentescoPermitido(valoresForm?.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm?.Parentesco)),
        verificarIdadePreenchida(valoresForm?.Idade),
        verificarCategoriaPrenchida(valoresForm?.Categoria),
        verificarParentescoPrenchido(valoresForm?.Parentesco),
        verificarSemAdicional(valoresForm?.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependenteSemValorAdicionalObrigatorio = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm?.Parentesco),
        verificarParentescosSemValorAdicionalRegrasEspeciais(valoresForm?.Parentesco),
        verificarIdadePreenchida(valoresForm?.Idade),
        verificarCategoriaPrenchida(valoresForm?.Categoria),
        verificarParentescoPrenchido(valoresForm?.Parentesco),
        verificarSemAdicional(valoresForm?.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm?.Seq, valoresForm?.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorAte64Anos = valoresForm => {
    const arrayDeValidacoes = [
        (verificarParentescoNaoPermitido(valoresForm.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorConjugeMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoConjuge(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaiorIgual65Anos = valoresForm => {
    const arrayDeValidacoes = [
        (verificarParentescoNaoPermitido(valoresForm.Parentesco) && !verificarParentescosComRegrasEspeciais(valoresForm.Parentesco)),
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMaeMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoMae(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiAte64Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPaiMaiorIgual65Anos = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        verificarGrauParentescoPai(valoresForm.Parentesco),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)

    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorExConjugeMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoExConjuge(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorMadrastaMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoMadrasta(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorPadrastoMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarGrauParentescoPadrasto(valoresForm.Parentesco),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescosComRegrasEspeciaisMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte65(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte65(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescosComRegrasEspeciaisAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        idadeAte64(valoresForm.Idade),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarAdicionalAte64(valoresForm.Categoria),
        verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesComAdicionalElegivelAte64 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosComAdicionalElegivel(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        idadeAte64(valoresForm.Idade),
        !verificarAdicionalAte65(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorDependentesComAdicionalElegivelMaiorIgual65 = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificarParentescosComRegrasEspeciais(valoresForm.Parentesco),
        verificarParentescosComAdicionalElegivel(valoresForm.Parentesco),
        verificarIdadePreenchida(valoresForm.Idade),
        verificarCategoriaPrenchida(valoresForm.Categoria),
        verificarParentescoPrenchido(valoresForm.Parentesco),
        idadeAte65(valoresForm.Idade),
        !verificarAdicionalAte64(valoresForm.Categoria),
        !verificarPossuiDependenteDeGrauEquivalenteSemAdicional(dependentes, valoresForm.Seq, valoresForm.Parentesco)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

export const validatorParentescoEmDuplicidade = (valoresForm, dependentes) => {
    const arrayDeValidacoes = [
        verificaSeJaPossuiParentescoSelecionado(dependentes, valoresForm)
    ];

    return arrayDeValidacoes.every(validacao => validacao === true);
};

const verificaSeJaPossuiParentescoSelecionado = (dependentes, values) => {
    const seq = values.Seq;
    const parentesco = values.Parentesco;
    const parentescosQuePodemSerMaisQueUm = ['5', '50', '03', '07', '10006', '10016', '22', '12', '20', '19', '24', '32'];

    if (!parentesco) {
        return false;
    }

    if (parentescosQuePodemSerMaisQueUm.includes(parentesco.trim())) {
        return false;
    }

    const possuiParentescoSelecionado = dependentes.filter(dependente => dependente['GrauParentesco.Grau'].trim() === parentesco.trim());

    if (!possuiParentescoSelecionado.length) {
        return false;
    }

    if (parentesco.trim() === '15') {
        return possuiParentescoSelecionado.length === 2;
    }

    if (parentesco.trim() === 'AVô') {
        return possuiParentescoSelecionado.length === 4;
    }

    if (seq) {
        return seq !== possuiParentescoSelecionado[0].Seq;
    }

    return true;
};

export const parentescosComRegrasEspeciais = [
    '01', //pai
    '20008', //padrasto

    '02', //mae
    '20007',  //madrasta

    '10', //esposo
    '32' //ex conjuge
];

export const parentescosSemValorAdicionalObrigatorioEmCasosEspeciais = [
    '01',
    '02',
    '10'
];

export const parentescosComAdicionalElegivel = [
    '20008',
    '20007',
    '32'
];

export const parentescosPermitidos = [
    '01',
    '02',
    '10',
    '10006',
    '15',
    '5',
    '50',
    '32',
    '20008',
    '20007'
];

export const grausEquivalentes = {
    '01': '20008',
    '20008': '01',

    '02': '20007',
    '20007': '02',

    '10': '32',
    '32': '10'
};

const verificarParentescoPermitido = parentesco => {
    if (parentesco) {
        const idParentesco = buscarIdParentesco(parentesco);
        const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === idParentesco);

        return parentescoEncontrado !== undefined ? true : false;
    }

    return true;
};

const verificarParentescoNaoPermitido = parentesco => {
    if (parentesco) {
        const idParentesco = buscarIdParentesco(parentesco);
        const parentescoEncontrado = parentescosPermitidos.find(itemParentesco => itemParentesco === idParentesco);

        return parentescoEncontrado !== undefined ? false : true;
    }

    return true;
};

const verificarParentescosComRegrasEspeciais = parentesco => {
    if (parentesco) {
        const idParentesco = buscarIdParentesco(parentesco);
        const parentescoEncontrado = parentescosComRegrasEspeciais.find(itemParentesco => itemParentesco === idParentesco);

        return parentescoEncontrado ? true : false;
    }

    return true;
};

const verificarParentescosSemValorAdicionalRegrasEspeciais = parentesco => {
    const parentescoEncontrado = parentescosSemValorAdicionalObrigatorioEmCasosEspeciais.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarParentescosComAdicionalElegivel = parentesco => {
    const parentescoEncontrado = parentescosComAdicionalElegivel.find(itemParentesco => itemParentesco === parentesco);

    return parentescoEncontrado ? true : false;
};

const verificarPossuiDependenteDeGrauEquivalenteSemAdicional = (dependentes, seq, parentesco) => {
    const dependente = dependentes.find(dependente => {
        const dependenteGrauParentesco = dependente['GrauParentesco.Grau'].trim();
        const dependenteGrauEquivalente = grausEquivalentes[dependenteGrauParentesco];

        const dependenteCategoria = dependente['CategoriaParentesco.Categoria'];

        return (dependenteGrauParentesco === parentesco || dependenteGrauEquivalente === parentesco) && dependenteCategoria === 'ZELO' && dependente.Seq !== seq;
    });

    return dependente ? true : false;
};

const verificarGrauParentescoConjuge = parentesco => parentesco === '10';

const verificarGrauParentescoMae = parentesco => parentesco === '02';

const verificarGrauParentescoPai = parentesco => parentesco === '01';

const verificarGrauParentescoExConjuge = parentesco => parentesco === '32';

const verificarGrauParentescoMadrasta = parentesco => parentesco === '20007';

const verificarGrauParentescoPadrasto = parentesco => parentesco === '20008';

const verificarIdadePreenchida = idade => idade !== '' && idade !== null;
const verificarCategoriaPrenchida = categoria => categoria !== '';
const verificarParentescoPrenchido = parentesco => parentesco !== '';
const verificarSemAdicional = categoria => categoria?.trim() !== 'ZELO';
const verificarAdicionalAte64 = categoria => categoria?.trim() !== 'ZSA64';
const verificarAdicionalAte65 = categoria => categoria?.trim() !== 'ZSM65';
const idadeAte64 = idade => idade <= 64;
const idadeAte65 = idade => idade >= 65;

const parentescos = {
    '01': 'PAI',
    '20008': 'PADRASTO',
    '02': 'MAE',
    '20007': 'MADRASTA',
    '10': 'ESPOSO(A)',
    '32': 'EX-CONJUGE',
    '15': 'SOGRO(A)',
    '5': 'FILHO(A)',
    '50': 'FILHO(A) ADOTIVO',
    '03': 'IRMA(O)',
    '07': 'SOBRINHO(A)',
    '10006': 'ENTEADO(A)',
    '10016': 'OUTROS',
    '12': 'NETO(A)',
    '22': 'PRIMO(A)',
    '19': 'GENRO',
    '20': 'NORA',
    '24': 'TIO(A)',
    'AVô': 'AVO',
    'PET': 'PET (ANIMAL)'
};

const buscarIdParentesco = string => {
    if (Object.keys(parentescos).includes(string)) {
        return string;
    }

    for (const [numero, parentesco] of Object.entries(parentescos)) {
        if (parentesco === string.toUpperCase()) {
            return numero;
        }
    }

    return null;
};

export const retornaLabelDoValorParentesco = valueParentesco => {
    const parentesco = valueParentesco.trim();

    if (parentesco === '15') {
        return `Só é permitido dois dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'AVô') {
        return `Só é permitido quatro dependentes do tipo  ${parentescos[`${parentesco}`]}`;
    }

    if (parentesco === 'PET') {
        return '';
    }

    return `Só é permitido um dependente do tipo  ${parentescos[`${parentesco}`]}`;
};

const categoriasPet = ['ZPE26', 'ZPEAD', 'ZPET', 'ZPETA', 'ZPETL'];

export const verificarExcecaoPetPorLocalidade = (categoria, parentesco) => categoriasPet.includes(categoria) && parentesco === 'PET';

export const comparaRegrasDepAtuaisComDepUpSell = (dependentes, subGrupoSelecionadoUpSell) => {
    for (const dep of dependentes) {
        const parentesco = dep['GrauParentesco.Grau'];
        const categoria = dep.Categoria;
        const idade = dep.Idade;
        const seq = dep.Seq;
        const messageErroPadrao = 'Para dependentes do tipo Irmã (o), Sobrinho (a), Outros, Neto (a), Primo (a), Tio (a), Avo e Pet (animal)';

        const mensagensErro = {
            semAdicional: 'Dependentes do tipo Pais, Filhos, Cônjuge, Sogro (a), Enteados e Adotivos só podem ser inseridos SEM VALOR ADICIONAL.',
            adicionalComCategoriaSemAdicional: `${messageErroPadrao} não é permitido SEM VALOR ADICIONAL, dependente Seq: ${seq}.`,
            adicionalAte64: `${messageErroPadrao} até 64 anos, o adicional permitido é o ZELO SUPREMO ATÉ 64.`,
            adicionalAte65: `${messageErroPadrao} acima de 65 anos, o adicional permitido é o ZELO SUPREMO MAIS 65.`,
            categoriaNaoPermitida: `O dependente com a sequência ${seq} possui uma categoria inválida (${categoria}) para o plano ${subGrupoSelecionadoUpSell}. Por favor, edite ou remova o dependente para continuar.`
        };

        const categoriasPermitidas = ['ZELO', 'ZSA64', 'ZSM65', 'ZPETL'];

        if (!categoriasPermitidas.includes(categoria)) {
            return mensagensErro.categoriaNaoPermitida;
        }

        if (!verificarSemAdicional(categoria)) {
            if (!verificarParentescoPermitido(parentesco?.trim())) {
                if (parentescosComRegrasEspeciais.includes(parentesco?.trim())) {
                    return mensagensErro.semAdicional;
                } else {
                    return mensagensErro.adicionalComCategoriaSemAdicional;
                }
            }
        } else if (idadeAte64(idade) && verificarSemAdicional(categoria)) {
            if (categoria !== 'ZPETL' && verificarAdicionalAte64(categoria)) {
                return mensagensErro.adicionalAte64;
            }
        } else if (idadeAte65(idade) && verificarSemAdicional(categoria)) {
            if (categoria !== 'ZPETL' && verificarAdicionalAte65(categoria)) {
                return mensagensErro.adicionalAte65;
            }
        }
    }
};